import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Motive } from '../../../../../../shared/types/systemConfiguration/motives';

export const useMotiveRegisterHistory = (motive?: Motive) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = motive || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [motive]);

    return {
        formik,
    };
};
